<template>
  <volcan-card-layout
    :title="getTitle"
    icon="fa fa-save"
    class="save"
    :loading="vueMv.loading"
  >
    <template v-if="vueMv.item">
      <volcan-card-content v-if="showUpdatedOnUtc">
        <i class="fa fa-clock-o" aria-hidden="true"></i>
        Dernière mise à jour : <span class="time">{{ formatDateFromNow(vueMv.item.updatedOnUtc) }}</span>
      </volcan-card-content>
      <volcan-card-content v-if="showVersion">
        <i class="fa fa-clock-o" aria-hidden="true"></i>
        Version : <span class="time">{{ vueMv.item.versionName }}</span>
      </volcan-card-content>
      <volcan-card-content v-if="showPreview">
        <template v-if="shouldPrepare">
          <button class="btn btn-secondary" @click.prevent="savePreview">
            <i class="fas fa-globe"></i> {{ $t("save.labels.preparePreview") }}
          </button>
        </template>
        <template v-else>
          <div class="title-get-admin">
            <i class="fas fa-globe"></i> {{ $t("save.labels.preview") }}
          </div>
          <ul>
            <li v-for="url in urls" :key="url.languageId">
              <a :href="url.url" target="_blank">{{ url.name }}</a>
            </li>
          </ul>
          <volcan-alert :alert="warning" />
        </template>
      </volcan-card-content>
      <div class="card-footer">
        <div
          class="btn-group"
          role="group"
          aria-label="Button group with nested dropdown"
        >
          <button
            type="submit"
            class="btn btn-primary"
            v-html="getSaveTxt"
          ></button>
          <div class="btn-group" role="group" v-if="hasDropdown">
            <button
              id="btnGroupDrop1"
              type="button"
              class="btn btn-primary dropdown-toggle"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i class="fas fa-caret-down"></i>
            </button>
            <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
              <button
                v-if="showSaveThenList"
                v-on:click="saveAndBack"
                type="submit"
                class="dropdown-item"
                v-html="getSaveBackToListTxt"
              ></button>
              <button
                v-if="showSaveThenAdd"
                v-on:click="saveAndAdd"
                type="submit"
                class="dropdown-item"
                v-html="getSaveBackToAddTxt"
              ></button>
            </div>
          </div>
        </div>
        <template v-if="showDelete">
          <volcan-btn-delete :deleteCallback="vueMv.deleteModal" />
          <volcan-modal :data="vueMv.modalInfo" :action="vueMv.deleteItem" />
        </template>
      </div>
    </template>
  </volcan-card-layout>
</template>
<script>
import en from "./admin-en.json";
import fr from "./admin-fr.json";
import helpers from '@mixins/helpers.js'
export default {
  name: "volcan-save",
  mixins: [helpers],
  beforeMount() {
    this.$i18n.add("fr", fr);
    this.$i18n.add("en", en);
  },
  data: function() {
    return {
      id: null,
      urls: [],
      prepped: false,
      warning: {
        success: true,
        message: "message",
        showClose: false
      }
    };
  },
  props: {
    title: { type: String },
    saveTxt: { type: String },
    vueMv: { type: Object },
    showDelete: {
      type: Boolean,
      default: true
    },
    showPreview: {
      type: Boolean,
      default: true
    },
    showVersion: {
      type: Boolean,
      default: false
    },
    showUpdatedOnUtc: {
      type: Boolean,
      default: true
    },
    showSaveThenList: {
      type: Boolean,
      default: false
    },
    showSaveThenAdd: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.warning.message = this.$t("save.labels.warning");
  },
  watch: {
    "vueMv.$isModified"(newVal, oldVal) {
      this.prepped = false;
    }
  },
  computed: {
    getTitle() {
      return this.$t("save.labels.title");
    },
    getSaveTxt() {
      return this.$t("save.labels.save");
    },
    getSaveBackToListTxt() {
      return this.$t("save.labels.saveBackToList");
    },
    getSaveBackToAddTxt() {
      return this.$t("save.labels.saveBackToAdd");
    },
    isItemReady() {
      return this.vueMv.updateMode && (this.vueMv.item || false);
    },
    shouldPrepare() {
      return this.vueMv.$isModified || !this.prepped;
    },
    hasDropdown() {
      return this.showSaveThenList || this.showSaveThenAdd;
    }
  },
  methods: {
    getLanguageName(languageId) {
      return this.$languages.find(l => l.id === languageId).name;
    },
    savePreview() {
      this.vueMv.loading = true;
      let isModified = this.vueMv.$isModified;

      let url = `/api/preview/update`;
      let data = {
        itemId: this.vueMv.item.id,
        json: JSON.stringify(this.vueMv.item),
        moduleName: this.vueMv.moduleName
      };

      axios
        .put(url, data)
        .then(response => {
          let preview = response.data.data;
          let item = JSON.parse(preview.json);

          this.urls.splice(0, this.urls.length);
          item.resources.forEach(res => {
            let languageName = this.getLanguageName(res.languageId);
            let url = `/preview/${preview.moduleName}/${item.id}/${
              res.languageId
            }${res.seo.search.localUrl || ""}`;
            this.urls.push({
              languageId: res.languageId,
              name: languageName,
              url: url
            });
          });

          this.vueMv.$isModified = isModified;
          this.vueMv.loading = false;
          this.$nextTick().then(() => {
            this.prepped = true;
          });
        })
        .catch(error => {
          this.vueMv.alert.success = false;
          this.vueMv.alert.message = this.vueMv.manageErrorMessage({
            code: "error",
            messages: ["response error"]
          });
          this.vueMv.loading = false;
        });
    },
    saveAndBack() {
      this.vueMv.isSaveAndBack = true;
    },
    saveAndAdd() {
      this.vueMv.isSaveAndAdd = true;
    }
  }
};
</script>
<style scoped>
button {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// components/Custom/Save/save.vue